import { getPropsForClickTracking } from "../../utils/tracking";
import { textFromTD } from "../../utils/text";
import type { UpdateLocationData } from "../../@types/mapviewxs";
export interface Input {
  locationParams?: Record<string, any>;
  updateLocationModal?: UpdateLocationData;
  userLocationZipcode?: string;
  zipcodeValue?: string;
  distanceValue?: string;
  showErrorMessage?: boolean;
  distanceVariant?: "radio" | "slider";
  "on-postcode-change"?: ({ value }: { value: string }) => void;
  "on-use-user-zipcode"?: () => void;
  "on-distance-change"?: ({ value }: { value: string }) => void;
}
$ const {
  locationParams,
  updateLocationModal,
  userLocationZipcode,
  zipcodeValue,
  distanceValue,
  showErrorMessage,
  distanceVariant = "radio",
} = input;
$ const formData: any = locationParams || updateLocationModal || {};
$ const postalCodeEntry = formData.postalCodeEntry || {};
$ const distanceOptions = formData.distanceOptions || {};
$ const slider = formData.distanceSlider;
$ const distanceUnit = formData.distanceUnit || "km";
$ const {
  entry = {},
  title: postalCodeEntryTitle,
  validation,
  currentLocationIcon,
} = postalCodeEntry;
$ const { maxLength, label } = entry;
$ const useSlider = distanceVariant === "slider" && slider;

<div class="map-location-form">
  <div class="map-location-form__input">
    <ebay-textbox
      value=zipcodeValue
      on-input-change("emit", "postcode-change")
      placeholder=textFromTD(label)
      maxlength=maxLength
      aria-label=postalCodeEntryTitle?.text
      data-testid="map-location-form-postcode-input"
      invalid=showErrorMessage
      fluid
    >
      <if(userLocationZipcode)>
        <@postfix-icon>
          <ebay-icon-button
            data-testid="map-location-form-user-postcode-button"
            size="large"
            on-click("emit", "use-user-zipcode")
            aria-label=(currentLocationIcon?.action?.accessibilityText)
            ...getPropsForClickTracking(currentLocationIcon?.action?.trackingList)
          >
            <ebay-location-arrow-16-icon/>
          </ebay-icon-button>
        </@postfix-icon>
      </if>
    </ebay-textbox>

    <if(showErrorMessage)>
      <div class="map-location-form__input__error" data-testid="map-location-form-input-error">
        <ebay-inline-notice status="attention">
          <fe-textual-display model=validation?.validationErrorMessage/>
        </ebay-inline-notice>
      </div>
    </if>
  </div>

  <if(useSlider)>
    $ const sliderMin = slider?.min || 1;
    $ const sliderMax = slider?.max || 200;
    $ const sliderStep = slider?.step || 1;
    $ const sliderLabel = textFromTD(slider?.label);

    <div class="map-location-form__distance-slider">
      <map-distance-slider
        value=distanceValue
        min=sliderMin
        max=sliderMax
        step=sliderStep
        unit=distanceUnit
        label=sliderLabel
        on-change("emit", "distance-change")
      />
    </div>
  </if>
  <else-if(distanceOptions?.entries)>
    <fieldset class="map-location-form__distance-fieldset">
      <div class="map-location-form__title">
        <fe-textual-display model=distanceOptions?.heading/>
      </div>

      <for|distanceOption| of=distanceOptions.entries>
        $ const radioId = `map-location-form-distance-group-radio-${distanceOption.fieldId}`;
        $ const isSelected = distanceOption.fieldId === distanceValue;

        <span class="map-location-form__radio">
          <ebay-radio
            on-change("emit", "distance-change")
            id=radioId
            value=distanceOption.fieldId
            name="distance-radio-group"
            checked=isSelected
            size="large"
          />
          <label for=radioId>
            <fe-textual-display model=distanceOption.label/>
          </label>
        </span>
      </for>
    </fieldset>
  </else-if>
</div>
